import { useConfig } from '@exam-center/configuration';
import { GridViewOutlinedIcon } from '@shared/components';
import { useCallback } from 'react';

import MenuItem, { type MenuItemProps } from '../menu-item';

type BackToPortalMenuItemProps = Pick<MenuItemProps, 'minified'>;

function BackToPortalMenuItem(props: Readonly<BackToPortalMenuItemProps>) {
  const { loginUrl } = useConfig();

  const backToPortal = useCallback(() => {
    window.location.href = loginUrl;
  }, [loginUrl]);

  return (
    <MenuItem
      {...props}
      label='Back to Portal'
      icon={<GridViewOutlinedIcon />}
      onClick={backToPortal}
    />
  );
}

export default BackToPortalMenuItem;
